import { pdfjs } from 'react-pdf'

let isWorkerInitialized = false

export function initializePdfWorker() {
  if (!isWorkerInitialized) {
    pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()
    isWorkerInitialized = true
  }
}
